import {apiLog} from './utils.js';

declare const PRODUCT_NAME: string;

export const enum MessageId {
    APPLICATION_LOADED = 'APPLICATION_LOADED',
    OVERLAY_STATE = 'OVERLAY_STATE',
    AUTHENTICATION_STATE = 'AUTHENTICATION_STATE',
    LIVE_EVENTS_AMOUNT = 'LIVE_EVENTS_AMOUNT',
}

interface Message {
    origin?: string;
    id: MessageId;
}

export interface ApplicationLoadedMessage extends Message {
    id: MessageId.APPLICATION_LOADED;
}

export interface OverlayState extends Message {
    id: MessageId.OVERLAY_STATE;
    shown: boolean;
}

export interface AuthenticationState extends Message {
    id: MessageId.AUTHENTICATION_STATE;
    authenticated: boolean;
}

export interface LiveEventsAmountState extends Message {
    id: MessageId.LIVE_EVENTS_AMOUNT;
    liveEventsAmount: number;
}

export function postMessage(
    message: OverlayState | AuthenticationState | LiveEventsAmountState | ApplicationLoadedMessage
) {
    message.origin = PRODUCT_NAME;
    apiLog.debug('POST MESSAGE', message);
    window.postMessage(message);
}
